import React, { ReactNode } from "react";
import "./addbutton.scss";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
interface AddButtonProps {
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onGenarate?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  button?: boolean;
  generate?: boolean;
  buttonName?: string;
  generateName?: string;
  element?: ReactNode;
}
const AddButton: React.FC<AddButtonProps> = ({
  title,
  onClick,
  onGenarate,
  button = true,
  buttonName = "add",
  generateName = "Generate Report",
  element,
  generate = false
}) => {
  return (
    <div className="addbutton">
      {title ? <h4>{title}</h4> : <div></div>}
      <div className="action_buttons">
        {generate && (
          <button className="generate" onClick={onGenarate}>
            {generateName}
            <NoteAddIcon />
          </button>
        )}
        {button && (
          <button className="add" onClick={onClick}>
            {buttonName}
          </button>
        )}
        {element || null}
      </div>
    </div>
  );
};

export default AddButton;
